var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"this-skill-rating"},_vm._l((this.maxRate),function(i){return _c('img',{key:i,attrs:{"src":_vm.getSource(i),"alt":"star rating"}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }